import Select from 'react-select';
const SelectField = ({
    name,
    className,
    classNamePrefix,
    data,
    isSearchable = true,
    isClearable = true,
    isDisabled = false,
    isLoading = true,
    isMulti = false,
    placeholder = "Select...",
    selectedValue,
    onChange,
    onInputChange,
    filterOption
}: any) => {
    return (
        <>
            <Select
                id={name}
                name={name}
                className={className}
                classNamePrefix={classNamePrefix}
                options={data}
                isSearchable={isSearchable}
                isClearable={isClearable}
                isDisabled={isDisabled}
                isLoading={isLoading}
                isMulti={isMulti}
                placeholder={placeholder}
                value={
                    isMulti ? data?.filter((item: any) => selectedValue?.includes(item?.value))
                        : (typeof selectedValue === 'object' && selectedValue !== null) ? selectedValue
                            : selectedValue ? data?.find((item: any) => item?.value === selectedValue)
                                : selectedValue
                }
                onChange={onChange}
                defaultValue={
                    // isMulti ? data?.filter((item: any) => selectedValue?.includes(item?.value))
                    //     : selectedValue ? data?.find((item: any) => item?.value === selectedValue)
                    //         : selectedValue
                    isMulti ? data?.filter((item: any) => selectedValue?.includes(item?.value))
                        : (typeof selectedValue === 'object' && selectedValue !== null) ? selectedValue
                            : selectedValue ? data?.find((item: any) => item?.value === selectedValue)
                                : selectedValue
                }
                onInputChange={(value, actionMeta) => onInputChange?.(value, actionMeta)}
                filterOption={filterOption ?? (onInputChange ? () => true : undefined)}
            />
        </>
    )
};
export default SelectField;